function printUnsupportedPropWarning(componentName, propName, message) {
  console.warn(`Unsupported prop '${propName}' in '<${componentName} />'. ${message ? message : ''}`);
}

/**
 * Object bracket notation removes type safety. This function restores it.
 */
function objKey(obj, key) {
  return obj[key];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

export { isDefined, objKey, printUnsupportedPropWarning };
